import prom, { Labels } from 'promjs';
import { request } from './request';
import debug from 'debug';
const trace = debug('login-lib-metrics');

export interface MetricSet {
  call: () => void
  success: () => void
  failure: () => void
}
export class Metrics {
  private endpointUrl: string;
  private registry = prom();
  labels: Labels;
  constructor(endpointUrl: string, labels?: Labels) {
    this.endpointUrl = endpointUrl;
    this.labels = labels || {};
  }

  async postMetrics() {
    try {
      const response = await fetch(
        new Request(this.endpointUrl, {
          method: 'POST',
          body: this.registry.metrics()
        })
      );
      trace(response);
      this.registry.reset()
    } catch (error) {
      console.error(error);
    }
  }

  // metric naming guidance https://prometheus.io/docs/practices/naming/

  private validate_token_call_counter = this.registry.create('counter', 'login_lib_validate_token_call_total', 'A counter for silent login calls');
  private validate_token_success_counter = this.registry.create('counter', 'login_lib_validate_token_succes_total', 'A counter for silent login successes');
  private validate_token_failure_counter = this.registry.create('counter', 'login_lib_validate_token_failure_total', 'A counter for silent login failures');
  validateTokenMetrics(labels?: Labels): MetricSet {
    const self = this;
    labels = { ...this.labels, ...labels }
    return {
      call() {
        self.validate_token_call_counter.add(1, labels)
      },
      success() {
        self.validate_token_success_counter.add(1, labels)
        self.postMetrics();
      },
      failure() {
        self.validate_token_failure_counter.add(1, labels)
        self.postMetrics();
      }
    }
  }

  private login_call_counter = this.registry.create('counter', 'login_lib_login_call_total', 'A counter for silent login calls');
  private login_success_counter = this.registry.create('counter', 'login_lib_login_succes_total', 'A counter for silent login successes');
  private login_failure_counter = this.registry.create('counter', 'login_lib_login_failure_total', 'A counter for silent login failures');
  loginMetrics(labels?: Labels): MetricSet {
    const self = this;
    labels = { ...this.labels, ...labels }
    return {
      call() {
        self.login_call_counter.add(1, labels)
      },
      success() {
        self.login_success_counter.add(1, labels)
        self.postMetrics();
      },
      failure() {
        self.login_failure_counter.add(1, labels)
        self.postMetrics();
      }
    }
  }

  private get_token_silent_call_counter = this.registry.create('counter', 'login_lib_get_token_silent_call_total', 'A counter for silent login calls');
  private get_token_silent_success_counter = this.registry.create('counter', 'login_lib_get_token_silent_succes_total', 'A counter for silent login successes');
  private get_token_silent_failure_counter = this.registry.create('counter', 'login_lib_get_token_silent_failure_total', 'A counter for silent login failures');
  getTokenSilentMetrics(labels?: Labels): MetricSet {
    const self = this;
    labels = { ...this.labels, ...labels }
    return {
      call() {
        self.get_token_silent_call_counter.add(1, labels)
      },
      success() {
        self.get_token_silent_success_counter.add(1, labels)
        self.postMetrics();
      },
      failure() {
        self.get_token_silent_failure_counter.add(1, labels)
        self.postMetrics();
      }
    }
  }

  private register_email_call_counter = this.registry.create('counter', 'login_lib_register_email_call_total', 'A counter for silent login calls');
  private register_email_success_counter = this.registry.create('counter', 'login_lib_register_email_succes_total', 'A counter for silent login successes');
  private register_email_failure_counter = this.registry.create('counter', 'login_lib_register_email_failure_total', 'A counter for silent login failures');
  registerEmailMetrics(labels?: Labels): MetricSet {
    const self = this;
    labels = { ...this.labels, ...labels }
    return {
      call() {
        self.register_email_call_counter.add(1, labels)
      },
      success() {
        self.register_email_success_counter.add(1, labels)
        self.postMetrics();
      },
      failure() {
        self.register_email_failure_counter.add(1, labels)
        self.postMetrics();
      }
    }
  }

  private logout_call_counter = this.registry.create('counter', 'login_lib_logout_call_total', 'A counter for silent login calls');
  private logout_success_counter = this.registry.create('counter', 'login_lib_logout_succes_total', 'A counter for silent login successes');
  private logout_failure_counter = this.registry.create('counter', 'login_lib_logout_failure_total', 'A counter for silent login failures');
  logoutMetrics(labels?: Labels): MetricSet {
    const self = this;
    labels = { ...this.labels, ...labels }
    return {
      call() {
        self.logout_call_counter.add(1, labels)
      },
      success() {
        self.logout_success_counter.add(1, labels)
        self.postMetrics();
      },
      failure() {
        self.logout_failure_counter.add(1, labels)
        self.postMetrics();
      }
    }
  }
}


